import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { Zone } from '../models/zone.model';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  private apiUrl = `${environment.sgcApi}`;
  private zoneRoute = 'zone';

  constructor(
    private httpClient: HttpClient,
  ) {}

  getZones() : Observable<Zone[]> {
    let endpoint = `${this.apiUrl}${this.zoneRoute}/map`;
    return this.httpClient.get<Zone[]>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(Zone, data as Zone[]);
    }));
  }

  getZonesByUserAndExercise(user: string, exercise: number) : Observable<Zone[]> {
    let endpoint = `${this.apiUrl}${this.zoneRoute}/user/${user}/exerciseId/${exercise}/map`;
    return this.httpClient.get<Zone[]>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(Zone, data as Zone[]);
    }));
  }
}
